import $ from "jquery";

(async () => {
    const els =
        $(".dpl-mailchimp, .block-editor");

    if(els.length>0) {
        await import('./scripts/Client.js');
    }
})();

